import { useDataLoaderHooks } from './use-dataloader-hooks'

export const useCategoryNavigation = (isActive: boolean) => {
  const { categoryNavigation } = useDataLoaderHooks()

  return (
    categoryNavigation(isActive) || {
      data: null,
      error: null,
      isValidating: true,
    }
  )
}
